import React from 'react';

import { IIconProps, TIconType } from '../interface';

const NotificationFilledIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			height='24'
			width='24'
			{...props?.innerSvgProps}
		>
			<g stroke='#4D4DB3'>
				<path
					d='M8.999 21h6'
					fill='none'
					transform='matrix(1.38648 0 0 1.24054 -4.645 -2.886)'
				/>
				<path
					d='M5.269 9.749c0-.888.174-1.77.512-2.589a6.762 6.762 0 0 1 1.471-2.195 6.711 6.711 0 0 1 2.2-1.46A6.723 6.723 0 0 1 12.047 3c3.714.028 6.683 3.11 6.683 6.833v.667c0 3.354.704 5.306 1.324 6.373a.754.754 0 0 1-.273 1.024.748.748 0 0 1-.375.1H4.592a.738.738 0 0 1-.371-.1.734.734 0 0 1-.274-.274.729.729 0 0 1-.101-.375c0-.132.036-.261.101-.375.617-1.067 1.322-3.02 1.322-6.373zm0 0'
					fill='#4D4DB3'
					transform='matrix(1.38648 0 0 1.24054 -4.645 -2.886)'
				/>
			</g>
		</svg>
	);
};

export default NotificationFilledIcon;
